import React from "react";
import { Logo } from "../../assets/images";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faCircleInfo, 
  faPhone, 
  faEnvelope, 
  faGraduationCap, 
  faPeopleGroup, 
  faLink,
  faMapMarkerAlt
} from "@fortawesome/free-solid-svg-icons";
import "./footer.css";
const Footer = () => {
  return (
    <footer className="w-full bg-white pt-20 pb-10 border-t border-gray-100 relative overflow-hidden">
      {/* Decorative element */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-primary/5 blur-[100px] rounded-full -translate-y-1/2"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-16">
          
          {/* Brand Column */}
          <div className="lg:col-span-4 space-y-8">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center p-2">
                <img alt="logo" src={Logo} className="w-full h-full object-contain" />
              </div>
              <div>
                <h2 className="text-2xl font-black text-title tracking-tight tracking-tighter">FOK <span className="text-primary italic">NJE7EK</span></h2>
                <p className="text-sm text-text font-medium">Apprendre, grandir, réussir</p>
              </div>
            </div>
            
            <p className="text-text leading-relaxed max-w-sm">
              Votre plateforme d'apprentissage moderne dédiée à l'excellence académique. Rejoignez des milliers d'étudiants vers la réussite.
            </p>
            
            <div className="flex space-x-3">
              {[
                { icon: <FacebookOutlinedIcon />, color: "#1877F2", url: "https://www.facebook.com/profile.php?id=100069589923551" },
                { icon: <InstagramIcon />, color: "#E4405F", url: "https://www.instagram.com/fok.nje7ek?igsh=eGU5ZWI0cjFmdDBi" },
                { icon: <YouTubeIcon />, color: "#CD201F", url: "https://youtube.com/@foknje7ek?si=Gx6DuBqwdkokJLUl" }
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-50 rounded-xl flex items-center justify-center text-gray-400 border border-gray-100 hover:bg-white hover:text-white hover:border-transparent transition-all duration-300 hover:shadow-lg group shadow-sm hover:translate-y-[-4px]"
                  style={{ '--hover-bg': social.color } as any}
                >
                  <span className="group-hover:text-white transition-colors duration-300 transform scale-110" style={{ color: 'inherit' }}>
                    {React.cloneElement(social.icon as any, { style: { fontSize: 24 } })}
                  </span>
                  <style>{`
                    .social-link-${i}:hover { background-color: ${social.color} !important; color: white !important; }
                  `}</style>
                </a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          <div className="lg:col-span-2 space-y-6">
            <h4 className="text-sm font-black text-title uppercase tracking-[0.2em] relative inline-block">
              Cours
              <span className="absolute -bottom-2 left-0 w-1/2 h-0.5 bg-primary"></span>
            </h4>
            <ul className="space-y-4 pt-4">
              {["Classroom", "E-learning", "Vidéos", "Cours gratuits"].map((link) => (
                <li key={link}>
                  <a href="#" className="text-text hover:text-primary transition-all duration-300 text-sm font-medium hover:translate-x-1 inline-block">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2 space-y-6">
            <h4 className="text-sm font-black text-title uppercase tracking-[0.2em] relative inline-block">
              Communauté
              <span className="absolute -bottom-2 left-0 w-1/2 h-0.5 bg-primary"></span>
            </h4>
            <ul className="space-y-4 pt-4">
              {["Apprenants", "Partenaires", "Notre Blog", "Centre d'aide"].map((link) => (
                <li key={link}>
                  <a href="#" className="text-text hover:text-primary transition-all duration-300 text-sm font-medium hover:translate-x-1 inline-block">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div className="lg:col-span-4 space-y-6">
            <h4 className="text-sm font-black text-title uppercase tracking-[0.2em] relative inline-block">
              Contact
              <span className="absolute -bottom-2 left-0 w-1/2 h-0.5 bg-primary"></span>
            </h4>
            <ul className="space-y-6 pt-4">
              <li className="flex items-start space-x-4 group">
                <div className="w-10 h-10 bg-primary/5 rounded-xl flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300 shrink-0 shadow-sm">
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                </div>
                <div className="pt-1">
                  <p className="text-title text-sm font-bold">Localisation</p>
                  <p className="text-text text-xs mt-1">Tunis, Tunisia</p>
                </div>
              </li>
              <li className="flex items-start space-x-4 group">
                <div className="w-10 h-10 bg-primary/5 rounded-xl flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300 shrink-0 shadow-sm">
                  <FontAwesomeIcon icon={faPhone} />
                </div>
                <div className="pt-1">
                  <p className="text-title text-sm font-bold">Téléphone</p>
                  <p className="text-text text-xs mt-1">+216 51 347 528</p>
                </div>
              </li>
              <li className="flex items-start space-x-4 group">
                <div className="w-10 h-10 bg-primary/5 rounded-xl flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300 shrink-0 shadow-sm">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <div className="pt-1">
                  <p className="text-title text-sm font-bold">Email</p>
                  <p className="text-text text-xs mt-1">contact@foknje7k.com</p>
                </div>
              </li>
            </ul>
          </div>

        </div>

        {/* Footer Bottom */}
        <div className="pt-10 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-text text-sm font-medium">
            © 2025 <span className="text-title font-black uppercase text-xs">Fok Nje7ek</span>. Tous droits réservés.
          </p>
          <div className="flex space-x-8">
            <a href="#" className="text-text hover:text-primary text-xs font-bold transition-colors">Conditions</a>
            <a href="#" className="text-text hover:text-primary text-xs font-bold transition-colors">Confidentialité</a>
            <a href="#" className="text-text hover:text-primary text-xs font-bold transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;